import React from "react";

/**
 * R6 A12 — Sticky bulk actions bar at bottom of viewport.
 */
export default function BulkActionsBar({
  selectedCount,
  canManage,
  onAssign,
  onStatus,
  onLogActivity,
  onAddNextContact,
  onExport,
  onDeselect,
  onBulkCompleteOverdue,
  onBulkSuspendOverdue,
}) {
  if (!selectedCount) return null;
  return (
    <div className="r6-bulk-actions-bar">
      <span className="r6-bulk-count">{selectedCount} selected</span>
      {canManage && (
        <button className="btn btn-secondary btn-sm" onClick={onAssign}>
          <i className="fas fa-user-tag" /> Assign to rep
        </button>
      )}
      <button className="btn btn-secondary btn-sm" onClick={onStatus}>
        <i className="fas fa-exchange-alt" /> Mark status
      </button>
      <button
        className="btn btn-secondary btn-sm"
        onClick={onBulkCompleteOverdue}
      >
        <i className="fas fa-check" /> Mark Overdue Complete
      </button>

      <button
        className="btn btn-secondary btn-sm"
        onClick={onBulkSuspendOverdue}
      >
        <i className="fas fa-pause" /> Suspend Overdue
      </button>
      {/*Temporarily hiding will remove after confirmation*/}
      {/*<button className="btn btn-secondary btn-sm" onClick={onLogActivity}>
        <i className="fas fa-plus-circle" /> Log activity
      </button>
      <button className="btn btn-secondary btn-sm" onClick={onAddNextContact}>
        <i className="fas fa-calendar-plus" /> Add Next Contact
      </button>*/}
      <button className="btn btn-secondary btn-sm" onClick={onExport}>
        <i className="fas fa-file-export" /> Export selected
      </button>
      <button className="btn btn-ghost btn-sm" onClick={onDeselect}>
        Deselect all
      </button>
    </div>
  );
}
